/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_PaletteInputs */

const en_shortcut_palette = /** @type {(inputs: Shortcut_PaletteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search or run`)
};

/**
* | output |
* | --- |
* | "Search or run" |
*
* @param {Shortcut_PaletteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const shortcut_palette = /** @type {((inputs?: Shortcut_PaletteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_PaletteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_shortcut_palette(inputs)
});